<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For My Father</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7ca2cc8a